import React from 'react';
import PropTypes from 'prop-types';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';

export function onReload() {
  window.location.reload();
}

export default function ErrorModal({
  message,
  title,
}) {
  return (
    <Dialog open>
      <DialogTitle>{ title }</DialogTitle>
      <DialogContent>
        <DialogContentText>
          { message }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onReload}>
          Reload
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const errorPropTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export {
  errorPropTypes,
};

ErrorModal.propTypes = errorPropTypes;
